module.exports = __webpack_public_path__ + "img/keyboard_backspace.5fc65882.svg";